import { contentSoundsBaseUrl } from "site/services/content-base-url";

function voiceUrl(file: string): string {
  return `${contentSoundsBaseUrl()}/${file}.aac`;
}

class PlayerService {
  currentPlayer: { stop: (byUser?: boolean) => Promise<void>; stopped$?: { actual: boolean } } | null = null;
  private transitionAudio: HTMLAudioElement | null = null;

  async stopCurrentPlayer() {
    const player = this.currentPlayer;
    if (!player?.stop) return;

    try {
      await player.stop(false);
    } catch {
          }

    if (this.currentPlayer === player) {
      this.currentPlayer = null;
    }
  }

  private stopTransitionAudio() {
    if (!this.transitionAudio) return;

    this.transitionAudio.pause();
    this.transitionAudio.removeAttribute("src");
    this.transitionAudio.load();
    this.transitionAudio = null;
  }

  playAudioAndWait(fileId: string | null | undefined): Promise<boolean> {
    if (!fileId) return Promise.resolve(false);

    return new Promise((resolve) => {
      void (async () => {
        await this.stopCurrentPlayer();
        this.stopTransitionAudio();

        const audio = new Audio();
        this.transitionAudio = audio;
        audio.src = voiceUrl(fileId);

        const finish = (ok: boolean) => {
          if (this.transitionAudio === audio) {
            this.stopTransitionAudio();
          }
          resolve(ok);
        };

        audio.addEventListener("ended", () => finish(true), { once: true });
        audio.addEventListener("error", () => finish(false), { once: true });

        try {
          await audio.play();
        } catch {
          finish(false);
        }
      })();
    });
  }
}

export const playerService = new PlayerService();
